let getList = [
    {//登录接口
      url : '/fbUser/doLogin',
      name : 'doLogin',
    },
    {//城市接口
      url : '/official/wxCityQuery',
      name : 'wxCityQuery',
    },
    {//暂存接口
      url : '/official',
      name : 'tempNoQuery',
    },
    {//获取流程数据
      url : '/officialApply',
      name : 'officialApply',
    },
    // 请求支付参数
    {
      url: '/official/payment',
      name: 'payment'
    },
     {// 请求上年报价方案
      url: '/official/queryCoverQuote',
      name: 'queryCoverQuote'
    },
    {// 心跳
      url: '/official/userInfo',
      name: 'heartBeat'
    },
    {// 查询机构是否开通电子签名
      url: '/official/queryElecSignConfig',
      name: 'queryElecSignConfig'
    },
    {//查询机构
      url: '/official/queryDeptByCity',
      name: 'queryDeptByCity'
    },
    {//查询车牌前缀
      url: '/official/queryVhlNoPre',
      name: 'queryVhlNoPre'
    },
    {//查询节假日
      url: '/queryHolidayFlagInfo',
      name: 'queryHolidayInfo'
    },
    {//init初始化获取flowId
      url: '/outside/init',
      name: 'initToGetFlowId'
    },
     // 新车录牌短信验证
    {
      url: '/endorse/outside/endorIdentCode',
      name: 'endorIdentCode'
    },
    {
      url: '/h5Image/outside/ocrImageId', ///获取ocrImageId信息
      name: 'ocrImageId',
    },
    {
      url: '/queryPopFrameInfo', // 查询弹框自定义提示内容
      name: 'queryPopFrameInfo',
    },
    {
      url: '/checkDigitalByCompany', // 机构是否开通数电发票
      name: 'checkDigitalByCompany',
    },
    {
      url: '/official/queryOperationalVehicleInfo',
      name: 'getVehicleInfo'
    }
  ];
  export default getList;
  